import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "../lib/api";
import { PageHero, Loader } from "../components/ui-bits";
import { Reveal } from "../components/Reveal";
import { MediaImage } from "../components/MediaImage";

const BG = "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function CSR() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/csr").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="csr-page">
      <PageHero
        eyebrow="Corporate Social Responsibility"
        title="Giving back to the communities we serve."
        subtitle="From pandemic relief to promoting culture and sustainability — our commitment goes beyond business."
        bg={BG}
      />

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {items === null ? <Loader label="Loading initiatives" /> : (
          <div className="space-y-16">
            {items.length === 0 && (
              <div className="text-center text-slate-400">
                <Heart className="w-10 h-10 text-emerald-500 mx-auto mb-4" />
                <p>CSR initiatives will appear here soon.</p>
              </div>
            )}
            {items.map((c, i) => (
              <Reveal key={c.id} delay={0.05}>
                <article className="card-vertical rounded-2xl p-8 lg:p-10" data-testid={`csr-item-${c.slug}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <Heart className="w-5 h-5 text-emerald-400" />
                    <h2 className="text-2xl font-display font-bold text-white">{c.title}</h2>
                  </div>
                  {c.image_url && (
                    <div className="rounded-xl overflow-hidden mb-6">
                      <MediaImage src={c.image_url} alt={c.title} className="w-full max-h-[60vh] object-cover" />
                    </div>
                  )}
                  <div className="prose-emerald max-w-none">
                    {(c.body || []).map((p, j) => <p key={j}>{p}</p>)}
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
